import { render } from "solid-js/web";
import { Signal, createEffect, createSignal } from "solid-js";
import Modal from '../st-modal/st-modal'
import Button from '../st-button/st-button'

export function showConfirmation(title: string, prompt: string): Promise<void> {
    return new Promise((yes, no) => {
        // container is required because dispose will clear whatever node we use
        const container = document.createElement('div');
        document.body.appendChild(container);

        let dispose = () => { };
        dispose = render(() => <ConfirmationDialog
            onClose={() => { dispose(); container.remove(); }}
            onYes={yes}
            onNo={no}
            title={title}
            prompt={prompt} />, container);
    });
}

export class ConfirmationDialogProps {
    onClose?: () => void;
    onYes = () => { };
    onNo = () => { };
    title: string = '';
    prompt: string = '';
}

export default function ConfirmationDialog(props: ConfirmationDialogProps) {
    const [show, setShow] = createSignal(true);

    createEffect(() => {
        if (!show()) {
            props.onClose?.call(props);
        }
    });

    return <Modal title={props.title} show={[show, setShow]}>
        <div style="padding: 10px 15px; max-width: 320px; text-align: center">{props.prompt}</div>
        <div class="flexbox horizontal middle padded">
            <div class="auto"></div>
            <div>
                <Button focused type="success" icon="fa fa-check" onClick={() => { setShow(false); props.onYes(); } }>Yes</Button>
            </div>
            <div>
                <Button type="default" icon="fa fa-times" onClick={() => { setShow(false); props.onNo() } }>No</Button>
            </div>
            <div class="auto"></div>
        </div>
    </Modal>
}

ConfirmationDialog.defaultProps = new ConfirmationDialogProps();
